import { fetchCurrentUser } from '../../ducks/user.duck';
import { getSpecificUserGPTS } from '../../util/api';
import { GROUP_PAYMENT_STATUS_ACTIVE } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import { fetchAdminModerator } from '../AdminPanelModeratorsPage/AdminPanelModeratorsPage.duck';
import {
  fetchSpaceList,
  getCurrentUserCircleAuthParams,
  getSpaceDetails,
  requestSpaceDetails,
  setInitalLoadToken,
  toggleCreateComment,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import { findGroupJoin } from '../DiscoverGroupsCommunityPage/DiscoverGroupsCommunityPage.duck';
import { fetchGroupFolder, fetchGroupPayment } from '../MyGroupCommunityPage/MyGroupCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/JoinedGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/JoinedGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/JoinedGroupPage/ERROR_SPACE_DETAILS';

export const SUCCESS_FECTH_GPTS = 'app/JoinedGroupPage/SUCCESS_FECTH_GPTS';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,

  gptsDetails: null
};

export default function joinedGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case SUCCESS_FECTH_GPTS:
      return { ...state, gptsDetails: payload };

    default:
      return state;
  }
}

// export const requestSpaceDetails = () => ({
//   type: REQUEST_SPACE_DETAILS,
// });
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const successFetchGpts = data => ({
  type: SUCCESS_FECTH_GPTS,
  payload: data,
});

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { page = 1, sort = "latest" ,topicId } = parse(search);
  dispatch(requestSpaceDetails(page));
  return Promise.all([dispatch(fetchCurrentUser())])
    .then(async response => {
      // Get the current user's data from state
      const currentUser = getState().user.currentUser;
      const email = currentUser?.attributes?.email;

      // Get the community data from state
      const { spaceListData } = getState().CircleCommunityPage;

      if (email) {
        // fetch auth token on first load
        await setInitalLoadToken(getCurrentUserCircleAuthParams(currentUser));
        const promises = [];

        const spaceDetailsPromise = dispatch(getSpaceDetails({ spaceId: params.id, page: +page, sort , topicId }))
          .then((spaceDetailsData) => {
            const { spaceDetail } = spaceDetailsData || {};
            const { id: group_id, file_id = "file_id" } = spaceDetail || {};
            getSpecificUserGPTS({ group_id, file_id }).then((response) => {
              dispatch(successFetchGpts(response.gpts));

            }).catch(error => {
              console.log(error, "error")

            })
            return spaceDetailsData;
          })
          .catch((error) => {
            console.error("❌ Error fetching space details:", error);
          });

        promises.push(spaceDetailsPromise);

        // ✅ Fetch Group Folder
        promises.push(
          dispatch(
            fetchGroupFolder({
              payload: {
                groupId: params.id,
                isActive: true,
                isDelete: false,
              },
            })
          )
        );

        // ✅ Fetch Space List if necessary
        if (!spaceListData || spaceListData.length === 0) {
          promises.push(dispatch(fetchSpaceList()));
        }

        dispatch(findGroupJoin({
          email,
          spaceId: params.id
        }))

        // ✅ Toggle Comment (No need to wait)
        dispatch(toggleCreateComment(false));


        // ✅ Fetch Admin and Moderator
        dispatch(fetchAdminModerator({
          payload: {
            groupId: params.id,
            status: 'active',
            role: 'admin',
          },
        }));
        dispatch(fetchGroupPayment({
          payload: {
            groupId: params.id,
            status: GROUP_PAYMENT_STATUS_ACTIVE,
          },
          pageParams: {
            page: 1,
            perPage: 1,
          }
        }));

        // ✅ Return all promises
        Promise.all(promises);
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};
